module.exports = __webpack_public_path__ + "static/media/blue-1.8f95c346.png";